<template>
  <div>
    <b-card :title="isEdit ? $t('settings.city.edit') : $t('settings.city.add')">
      <validation-observer
        ref="form"
        #default="{ handleSubmit }"
      >
        <b-form @submit.prevent="handleSubmit(onSubmit)">
          <b-row>
            <b-col
              cols="12"
              md="6"
            >
              <validation-provider
                #default="{ errors }"
                name="name_ar"
                rules="required"
              >
                <b-form-group
                  :label="$t('settings.city.name_ar')"
                  label-for="name_ar"
                >
                  <b-form-input
                    id="name_ar"
                    v-model="form.name_ar"
                    :state="errors.length > 0 ? false : null"
                  />
                  <small class="text-danger">{{ errors[0] }}</small>
                </b-form-group>
              </validation-provider>
            </b-col>

            <b-col
              cols="12"
              md="6"
            >
              <validation-provider
                #default="{ errors }"
                name="name_en"
                rules="required"
              >
                <b-form-group
                  :label="$t('settings.city.name_en')"
                  label-for="name_en"
                >
                  <b-form-input
                    id="name_en"
                    v-model="form.name_en"
                    :state="errors.length > 0 ? false : null"
                  />
                  <small class="text-danger">{{ errors[0] }}</small>
                </b-form-group>
              </validation-provider>
            </b-col>

            <b-col
              cols="12"
              md="6"
            >
              <validation-provider
                #default="{ errors }"
                name="center_id"
                rules="required"
              >
                <b-form-group
                  label="المركز"
                  label-for="center_id"
                >
                  <v-select
                    id="center_id"
                    v-model="form.center_id"
                    :options="centersDropdown"
                    :reduce="val => val.id"
                    :get-option-label="option => option.name_ar"
                    :placeholder="$t('settings.city.center_id')"
                    :state="errors.length > 0 ? false : null"
                  />
                  <small class="text-danger">{{ errors[0] }}</small>
                </b-form-group>
              </validation-provider>
            </b-col>

            <b-col
              cols="12"
              md="6"
            >
              <b-form-group :label="$t('settings.city.is_active')">
                <b-form-checkbox
                  v-model="form.is_active"
                  switch
                >
                  {{ form.is_active ? $t('common.active') : $t('common.inactive') }}
                </b-form-checkbox>
              </b-form-group>
            </b-col>

            <b-col cols="12">
              <b-button
                type="submit"
                variant="primary"
                class="mr-1"
              >
                {{ $t('common.save') }}
              </b-button>
              <b-button
                variant="outline-secondary"
                @click="$router.go(-1)"
              >
                {{ $t('common.cancel') }}
              </b-button>
            </b-col>
          </b-row>
        </b-form>
      </validation-observer>
    </b-card>
  </div>
</template>

<script>
import {
  BCard, BForm, BRow, BCol, BFormGroup, BFormInput, BFormCheckbox, BButton,
} from 'bootstrap-vue'
import { ValidationObserver, ValidationProvider } from 'vee-validate'
import { required } from '@validations'
import vSelect from 'vue-select'
import { mapGetters } from 'vuex'
import ToastificationContent from '@core/components/toastification/ToastificationContent.vue'

export default {
  components: {
    BCard,
    BForm,
    BRow,
    BCol,
    BFormGroup,
    BFormInput,
    BFormCheckbox,
    BButton,
    ValidationObserver,
    ValidationProvider,
    vSelect,
  },
  data() {
    return {
      form: {
        name_ar: '',
        name_en: '',
        center_id: null,
        is_active: true,
      },
      required,
    }
  },
  computed: {
    ...mapGetters({
      centersDropdown: 'centers/dropdown',
    }),
    isEdit() {
      return !!this.$route.params.id
    },
  },
  mounted() {
    this.fetchCentersDropdown()
    if (this.isEdit) {
      this.fetchCity()
    }
  },
  methods: {
    fetchCentersDropdown() {
      this.$store.dispatch('centers/dropdown')
    },
    fetchCity() {
      this.$store.dispatch('cities/get', this.$route.params.id)
        .then(response => {
          this.form = { ...response.data }
        })
        .catch(error => {
          this.$toast({
            component: ToastificationContent,
            props: {
              title: this.$t('common.error'),
              icon: 'AlertTriangleIcon',
              variant: 'danger',
              text: (error.response && error.response.data && error.response.data.message) || error.message,
            },
          })
        })
    },
    onSubmit() {
      const action = this.isEdit ? 'update' : 'create'
      const payload = this.isEdit ? { id: this.$route.params.id, data: this.form } : this.form

      this.$store.dispatch(`cities/${action}`, payload)
        .then(() => {
          this.$toast({
            component: ToastificationContent,
            props: {
              title: this.$t('common.success'),
              icon: 'CheckIcon',
              variant: 'success',
              text: this.isEdit
                ? this.$t('settings.city.messages.update_success')
                : this.$t('settings.city.messages.create_success'),
            },
          })
          this.$router.push({ name: 'settings-cities' })
        })
        .catch(error => {
          this.$toast({
            component: ToastificationContent,
            props: {
              title: this.$t('common.error'),
              icon: 'AlertTriangleIcon',
              variant: 'danger',
              text: (error.response && error.response.data && error.response.data.message) || error.message,
            },
          })
        })
    },
  },
}
</script>

<style lang="scss" scoped>
@import '~@core/scss/vue/libs/vue-select.scss';
</style>
